'use client';

import type { Session } from 'next-auth';
import { NextIntlClientProvider } from 'next-intl';
import { Toaster } from 'react-hot-toast';
import AuthProvider from '@core/components/shared/api/auth/[...nextauth]/auth-provider';
import GlobalDrawer from '@core/components/shared/drawer-views/container';
import GlobalModal from '@core/components/shared/modal-views/container';
import NextProgress from '@core/components/next-progress';
import { JotaiProvider, ThemeProvider } from '@/app/shared/theme-provider';
import I18nextBridge from './i18next-bridge';

type Messages = Record<string, unknown>;

export function AppProviders({
  children,
  locale,
  messages,
  session,
}: React.PropsWithChildren<{
  locale: string;
  messages: Messages;
  session: Session | null;
}>) {
  return (
    <AuthProvider session={session}>
      <NextIntlClientProvider
        locale={locale}
        messages={messages}
        timeZone="Asia/Tashkent"
      >
        <I18nextBridge locale={locale} messages={messages}>
          <ThemeProvider>
            <NextProgress />
            <JotaiProvider>
              {children}
              <Toaster containerClassName="z-[999]" />
              <GlobalDrawer />
              <GlobalModal />
            </JotaiProvider>
          </ThemeProvider>
        </I18nextBridge>
      </NextIntlClientProvider>
    </AuthProvider>
  );
}
